module.exports = __webpack_public_path__ + "img/mv--avatar3.bf089e54.png";